import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = {
  class: "d-flex flex-column mb-7 fv-row text-center fw-bold",
  style: {"font-size":"10px","line-height":"15px","color":"#4f4f4f"}
}
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  type: "button",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "top-start",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = {
  src: "/media/svg/files/exclamation-circle.svg",
  alt: "",
  style: {"width":"auto"},
  class: "mx-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("We will follow up with you and keep you updated on our process.")), 1)
    ], 512), [
      [_vShow, _ctx.info_onboarding_msg]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t("What is your e-mail address?")) + " ", 1),
          _createElementVNode("a", _hoisted_7, [
            _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
              [_vShow, _ctx.info_home_msg]
            ])
          ]),
          _createVNode(_component_Tooltip)
        ]),
        _createVNode(_component_Field, {
          type: "text",
          class: "form-control form-control-solid",
          placeholder: "",
          name: "patient_s_email",
          disabled: "false"
        }),
        _createVNode(_component_ErrorMessage, {
          class: "fv-plugins-message-container invalid-feedback",
          name: "patient_s_email"
        })
      ])
    ])
  ]))
}